import { useEffect } from 'react'

import { isNil } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '../../Store/hooks/useStore'
import { useSelectionStyle } from '../useSelectionStyle'

export const useLineHeight = () => {
  const {
    lineHeightList,
    defaultLineHeight,
    currentLineHeight,
    setCurrentLineHeight
  } = useRichEditorStore(state =>
    pick(state, [
      'lineHeightList',
      'defaultLineHeight',
      'currentLineHeight',
      'setCurrentLineHeight'
    ])
  )

  const [lineHeight, setLineHeight] = useSelectionStyle({
    name: 'line-height',
    defaultValue: `${defaultLineHeight}`
  })

  useEffect(() => {
    if (!isNil(lineHeight)) {
      setCurrentLineHeight(Number.parseFloat(lineHeight))
    }
  }, [lineHeight, setCurrentLineHeight])

  return {
    lineHeightList,
    lineHeight: currentLineHeight,
    setLineHeight
  }
}
